import type { FarmstandState } from "./types";

const today = new Date().toISOString();

export const emptyState: FarmstandState = {
  id: "",
  account: null,
  access: null,
  settings: {
    name: "",
    slug: "",
    ownerName: "",
    inviteCode: "",
    paymentMethods: {
      venmo: "",
      zelle: "",
      paypal: "",
      cash: ""
    },
    brand: {
      primaryColor: "#2f6b4f",
      logoUrl: "",
      font: "Inter"
    }
  },
  contributors: [],
  invitations: [],
  inventory: [],
  orders: [],
  contributorSales: []
};

export const demoState: FarmstandState = {
  id: "stand-river-bend",
  account: {
    name: "Kody Crouch",
    email: "owner@example.com",
    phone: "555-0100"
  },
  access: {
    role: "owner",
    memberId: "contributor-owner",
    memberName: "Kody Crouch"
  },
  settings: {
    name: "River Bend Farmstand",
    slug: "river-bend",
    ownerName: "Kody Crouch",
    inviteCode: "TOMATO-742",
    paymentMethods: {
      venmo: "@riverbendstand",
      zelle: "pay@riverbend.example",
      paypal: "paypal.me/riverbendstand",
      cash: "Cash box at pickup shelf"
    },
    brand: {
      primaryColor: "#2f6b4f",
      logoUrl: "",
      font: "Inter"
    }
  },
  contributors: [
    {
      id: "contributor-owner",
      name: "Kody Crouch",
      email: "owner@example.com",
      phone: "555-0100",
      role: "owner"
    },
    {
      id: "contributor-arden",
      name: "Arden Miller",
      email: "arden@example.com",
      phone: "555-0142",
      role: "contributor"
    }
  ],
  invitations: [],
  inventory: [
    {
      id: "item-eggs",
      name: "Pasture eggs",
      contributorId: "contributor-owner",
      contributorName: "Kody Crouch",
      category: "Eggs",
      priceCents: 600,
      quantity: 18,
      unit: "dozen",
      updatedAt: today
    },
    {
      id: "item-tomatoes",
      name: "Cherry tomatoes",
      contributorId: "contributor-arden",
      contributorName: "Arden Miller",
      category: "Produce",
      priceCents: 450,
      quantity: 12,
      unit: "pint",
      updatedAt: today
    },
    {
      id: "item-honey",
      name: "Wildflower honey",
      contributorId: "contributor-owner",
      contributorName: "Kody Crouch",
      category: "Pantry",
      priceCents: 1200,
      quantity: 7,
      unit: "jar",
      updatedAt: today
    }
  ],
  orders: [
    {
      id: "order-sample",
      shopperName: "Maya Carter",
      shopperEmail: "maya@example.com",
      shopperPhone: "555-0177",
      paymentMethod: "venmo",
      status: "fulfilled",
      totalCents: 1050,
      createdAt: today,
      items: [
        {
          itemId: "item-eggs",
          name: "Pasture eggs",
          contributorId: "contributor-owner",
          contributorName: "Kody Crouch",
          quantity: 1,
          priceCents: 600
        },
        {
          itemId: "item-tomatoes",
          name: "Cherry tomatoes",
          contributorId: "contributor-arden",
          contributorName: "Arden Miller",
          quantity: 1,
          priceCents: 450
        }
      ]
    }
  ],
  contributorSales: [
    {
      orderId: "order-sample",
      itemId: "item-eggs",
      itemName: "Pasture eggs",
      quantity: 1,
      priceCents: 600,
      totalCents: 600,
      status: "fulfilled",
      createdAt: today
    }
  ]
};

export const contributorDemoState: FarmstandState = {
  id: "stand-maple-row",
  account: demoState.account,
  access: {
    role: "contributor",
    memberId: "contributor-kody-maple",
    memberName: "Kody Crouch"
  },
  settings: {
    ...demoState.settings,
    name: "Maple Row Market",
    slug: "maple-row",
    ownerName: "Arden Miller",
    inviteCode: "MAPLE-318",
    brand: {
      ...demoState.settings.brand,
      primaryColor: "#3a6484"
    }
  },
  contributors: [
    {
      id: "contributor-kody-maple",
      name: "Kody Crouch",
      email: "owner@example.com",
      phone: "555-0100",
      role: "contributor"
    }
  ],
  invitations: [],
  inventory: [
    {
      id: "item-maple-bread",
      name: "Sourdough loaf",
      contributorId: "contributor-kody-maple",
      contributorName: "Kody Crouch",
      category: "Bakery",
      priceCents: 900,
      quantity: 5,
      unit: "loaf",
      updatedAt: today
    },
    {
      id: "item-maple-greens",
      name: "Salad greens",
      contributorId: "contributor-arden-maple",
      contributorName: "Arden Miller",
      category: "Produce",
      priceCents: 550,
      quantity: 8,
      unit: "bag",
      updatedAt: today
    }
  ],
  orders: [],
  contributorSales: []
};
